// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","counter-border":"counter_counter-border__2osHo","inside-border":"counter_inside-border__gfYc3","button-border":"counter_button-border__2bFvW"};